export default __webpack_public_path__ + "locales/sk/ChangeUserTypeDialog.json?hash=5acbe6cd170078f780bf6ded211c305c";